var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeopleRestricted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.283,
    height: 16,
    viewBox: "0 0 13.283 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91674",
    d: "M14.7 5.8a3.6 3.6 0 1 0-3.6 3.6 3.607 3.607 0 0 0 3.6-3.6zm-5.6 0a2 2 0 1 1 2 1.963 1.985 1.985 0 0 1-2-1.963z",
    transform: "translate(-4.607 -2.2)",
    style: {
      fill: "#76a9fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91675",
    d: "m4.477 15.516-.4 1.554a2.382 2.382 0 0 0 2.339 3.108h5.564a.818.818 0 0 0 0-1.636H6.412a.58.58 0 0 1-.564-.327.665.665 0 0 1-.242-.736l.4-1.554a2.991 2.991 0 0 1 2.822-2.29h3.226a3.2 3.2 0 0 1 1.855.654.772.772 0 0 0 1.129-.082.8.8 0 0 0-.081-1.145 4.7 4.7 0 0 0-2.9-1.062H8.831a4.548 4.548 0 0 0-4.354 3.516z",
    transform: "translate(-3.962 -4.178)",
    style: {
      fill: "#76a9fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91676",
    d: "M19.28 16.845a.791.791 0 0 0-1.145 0l-.572.572-.572-.572a.81.81 0 0 0-1.145 1.145l.572.572-.572.572a.791.791 0 0 0 0 1.145.791.791 0 0 0 1.145 0l.572-.572.572.572a.791.791 0 0 0 1.145 0 .791.791 0 0 0 0-1.145l-.572-.572.572-.572a.791.791 0 0 0 0-1.145z",
    transform: "translate(-6.242 -5.016)",
    style: {
      fill: "#76a9fa"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleRestricted);
export default __webpack_public_path__ + "static/media/people-restricted.svg";
export { ForwardRef as ReactComponent };